import { TableCell } from '@mui/material';
import UptimeChart from 'app/routes/Analytics/HistoricalUptime/HistoricalUptimeList/UptimeChart';
import CCS1SVG from 'assets/images/plug-ccs1.svg?react';

export const onboardingHistoricalUptime = [
  {
    chargepoint: 'Cargador onboarding',
    asset: 'Asset onboarding',
    chargepointGroup: 'Grupo onboarding',
    uptime: <UptimeChart index={0} uptime={95} />,
    uptimeRaw: 95,
    offline: `${5} hrs.`,
    offlineRaw: 5,
    transactions: 100,
    energy: `${100} kWh`,
    energyRaw: 100,
    idle: '-',
    charging: '-',
    faulted: '-',
    expandableContent: [
      <>
        <TableCell />
        <TableCell align="center">
          <div className="d-flex justify-content-center">
            <div style={{ width: '16px' }} className="mr-2">
              <CCS1SVG />
            </div>
            Conector onboarding
          </div>
        </TableCell>
        <TableCell align="center">-</TableCell>
        <TableCell align="center">-</TableCell>
        <TableCell align="center">-</TableCell>
        <TableCell align="center">-</TableCell>
        <TableCell align="center">{50}</TableCell>
        <TableCell align="center">{`${parseFloat((10000 / 1000).toFixed(2))} kWh`}</TableCell>
        <TableCell align="center">{`${50} hras -  ${40}%`}</TableCell>
        <TableCell align="center">{`${50} hras -  ${50}%`}</TableCell>
        <TableCell align="center">{`${10} hras -  ${10}%`}</TableCell>
      </>,
    ],
  },
];
